import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function TermsAndConditions() {
  useEffect(() => {
    document.title = 'Terms & Conditions - School Launch';
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-amber-500 selection:text-black" data-id="element-299">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-black/80 backdrop-blur-md border-b border-zinc-800" data-id="element-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-301">
          <Link to="/" className="flex items-center" aria-label="SchoolLaunch - Home" data-id="element-302">
            <img src="https://cdn.magicpatterns.com/uploads/3aM3DA6U6f25P9EHkUZYxu/SCHOOL_LAUNCH_LOGO_black_2.png" alt="SchoolLaunch" className="h-10 w-auto" data-id="element-303" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-zinc-400 hover:text-amber-500 transition-colors" data-id="element-304">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-305" />
            <span className="hidden sm:inline" data-id="element-306">Back to Home</span>
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8" data-id="element-307">
        <div className="max-w-4xl mx-auto text-center" data-id="element-308">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-amber-500/10 text-amber-500 font-medium text-xs md:text-sm mb-6 border border-amber-500/20" data-id="element-309">
            Legal
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-4 leading-tight" data-id="element-310">
            Terms &{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-311">
              Conditions
            </span>
          </h1>
          <p className="text-zinc-400 text-sm md:text-base" data-id="element-312">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24 px-4 sm:px-6 lg:px-8" data-id="element-313">
        <div className="max-w-3xl mx-auto" data-id="element-314">
          <div className="rounded-2xl border border-zinc-800 bg-zinc-900/50 p-6 md:p-10 backdrop-blur space-y-10" data-id="element-315">
            <div data-id="element-316">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-317">
                1. Introduction
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-318">
                Welcome to{' '}
                <span className="font-bold text-white" data-id="element-319">School Launch</span>!
                These Terms and Conditions govern your use of our website
                located at{' '}
                <a href="https://school-launch.com/" className="text-amber-500 hover:text-amber-400 transition-colors" data-id="element-320">
                  https://school-launch.com/
                </a>
                , operated by{' '}
                <span className="font-bold text-white" data-id="element-321">Engage Media Group</span>
                . Your access and use of the Service is conditioned on your
                acceptance of and compliance with these Terms. These Terms apply
                to all visitors, users, and others who wish to access or use the
                Service. Please read these Terms and Conditions carefully before
                using our Service.
              </p>
            </div>

            <div data-id="element-322">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-323">
                2. Communications
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-324">
                By submitting your information through our website, you agree to
                receive newsletters, promotional or marketing materials, and
                other information that we may send. However, you may opt out of
                receiving any, or all, of these communications from us by
                following the unsubscribe link or instructions provided in any
                email we send.
              </p>
            </div>

            <div data-id="element-325">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-326">
                3. Services
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-327">
                School Launch provides digital marketing services for
                educational institutions, helping schools connect with
                prospective students and fill their enrollment capacity. Any
                specific promotions or campaigns available through the Service
                may be governed by rules separate from these Terms and
                Conditions.
              </p>
            </div>

            <div data-id="element-328">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-329">
                4. Intellectual Property
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-330">
                The Service and its original content (excluding content provided
                by users), features, and functionality are and will remain the
                exclusive property of{' '}
                <span className="font-bold text-white" data-id="element-331">Engage Media Group</span>{' '}
                and its licensors.
              </p>
            </div>

            <div data-id="element-332">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-333">
                5. Links to Other Websites
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-334">
                Our Service may contain links to third-party websites or
                services that are not owned or controlled by{' '}
                <span className="font-bold text-white" data-id="element-335">Engage Media Group</span>
                . We have no control over, and assume no responsibility for, the
                content, privacy policies, or practices of any third-party
                websites or services. We do not guarantee the offers of any of
                these entities or their websites.
              </p>
            </div>

            <div data-id="element-336">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-337">
                6. Limitation of Liability
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-338">
                In no event shall{' '}
                <span className="font-bold text-white" data-id="element-339">Engage Media Group</span>
                , nor its directors, employees, partners, agents, suppliers, or
                affiliates be liable for any indirect, incidental, special,
                consequential, or punitive damages, including but not limited to
                loss of profits, loss of data, use, goodwill, or other
                intangible losses, resulting from: (a) your access or use of, or
                inability to access or use, the Service; (b) any conduct or
                content of any third party on the Service; (c) any content
                obtained from the Service; (d) unauthorized access, use, or
                alteration of your transmissions or content, whether based on
                warranty, contract, tort (including negligence), or any other
                legal theory.
              </p>
            </div>

            <div data-id="element-340">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-341">
                7. Disclaimer
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-342">
                Your use of the Service is at your own risk. The Service is
                provided "AS IS" and "AS AVAILABLE" without warranties of any
                kind, whether express or implied, including but not limited to
                implied warranties of merchantability, fitness for a particular
                purpose, or non-infringement.
              </p>
            </div>

            <div data-id="element-343">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-344">
                8. Minors
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-345">
                We do not knowingly solicit data from or market to children
                under 18 years of age.
              </p>
            </div>

            <div data-id="element-346">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-347">
                9. Exclusions
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-348">
                Some jurisdictions do not allow the exclusion of certain
                warranties or the limitation of liability for consequential or
                incidental damages, so the above limitations may not apply to
                you.
              </p>
            </div>

            <div data-id="element-349">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-350">
                10. Governing Law
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-351">
                These Terms shall be governed and construed in accordance with
                the laws of the State of Florida, USA, without regard to its
                conflict of law provisions.
              </p>
            </div>

            <div data-id="element-352">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-353">
                11. Changes to These Terms
              </h2>
              <p className="text-zinc-300 leading-relaxed" data-id="element-354">
                We reserve the right, at our sole discretion, to modify or
                replace these Terms at any time. If a revision is material, we
                will provide at least 30 days' notice prior to any new terms
                taking effect.
              </p>
            </div>

            <div data-id="element-355">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-356">
                12. SMS Communications
              </h2>
              <div className="space-y-4 text-zinc-300 leading-relaxed" data-id="element-357">
                <p data-id="element-358">
                  School Launch provides digital marketing services for
                  educational institutions and communicates with opted-in users
                  via SMS for lead follow-ups, enrollment information, school
                  program details, and other education-related messages
                  requested by the user.
                </p>
                <p data-id="element-359">
                  You can cancel the SMS service at any time by texting{' '}
                  <span className="text-amber-500 font-bold" data-id="element-360">"STOP"</span> to{' '}
                  <a href="tel:9044672448" className="text-amber-500 hover:text-amber-400 transition-colors font-bold" data-id="element-361">
                    904-467-2448
                  </a>
                  . After sending "STOP", you will receive a confirmation
                  message and will no longer receive SMS messages from us. To
                  rejoin, simply sign up again as you did the first time.
                </p>
                <p data-id="element-362">
                  If you experience issues with the messaging program, reply
                  with the keyword{' '}
                  <span className="text-amber-500 font-bold" data-id="element-363">HELP</span> for
                  assistance, or contact us directly at{' '}
                  <a href="mailto:contact@school-launch.com" className="text-amber-500 hover:text-amber-400 transition-colors" data-id="element-364">
                    contact@school-launch.com
                  </a>
                  .
                </p>
                <p data-id="element-365">
                  Carriers are not liable for delayed or undelivered messages.
                </p>
                <p data-id="element-366">
                  Message and data rates may apply. Message frequency will vary.
                  If you have questions about your text plan or data plan,
                  please contact your wireless provider.
                </p>
                <p data-id="element-367">
                  For privacy-related questions, please read our{' '}
                  <Link to="/privacy-policy" className="text-amber-500 hover:text-amber-400 transition-colors font-medium" data-id="element-368">
                    Privacy Policy
                  </Link>
                  .
                </p>
              </div>
            </div>

            <div data-id="element-369">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-370">
                13. Contact Us
              </h2>
              <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-371">
                If you have any questions about these Terms, please contact us
                at:
              </p>
              <div className="rounded-xl border border-zinc-800 bg-black/40 p-5 space-y-2" data-id="element-372">
                <p className="text-zinc-300" data-id="element-373">
                  <span className="font-bold text-white" data-id="element-374">Email:</span>{' '}
                  <a href="mailto:contact@school-launch.com" className="text-amber-500 hover:text-amber-400 transition-colors" data-id="element-375">
                    contact@school-launch.com
                  </a>
                </p>
                <p className="text-zinc-300" data-id="element-376">
                  <span className="font-bold text-white" data-id="element-377">Phone:</span>{' '}
                  <a href="tel:9044672448" className="text-amber-500 hover:text-amber-400 transition-colors" data-id="element-378">
                    904-467-2448
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-12 border-t border-zinc-900" data-id="element-379">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-380">
          <Link to="/" className="flex items-center" aria-label="SchoolLaunch - Home" data-id="element-381">
            <img src="https://cdn.magicpatterns.com/uploads/3aM3DA6U6f25P9EHkUZYxu/SCHOOL_LAUNCH_LOGO_black_2.png" alt="SchoolLaunch" className="h-8 w-auto" data-id="element-382" />
          </Link>
          <div className="text-zinc-500 text-sm text-center" data-id="element-383">
            &copy; {new Date().getFullYear()} Engage Media Group. All rights
            reserved.
          </div>
          <div className="flex gap-6 text-sm text-zinc-400" data-id="element-384">
            <Link to="/privacy-policy" className="hover:text-amber-500 transition-colors" data-id="element-385">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="hover:text-amber-500 transition-colors" data-id="element-386">
              Terms
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}